import React, { useState, useEffect } from 'react';
import './Test.css';
import Contact from './Contact';
import CB from "./CB";

const TestCards = ({ goBack, savedGeneralData }) => {
  
  const [preservedData] = useState(() => {
    const saved = localStorage.getItem('testFormData');
    return saved ? JSON.parse(saved) : null;
  });

  const [showContactForm, setShowContactForm] = useState(false);
  const [showCircuitBreakerForm, setShowCircuitBreakerForm] = useState(false);
 
  const [closePositionData, setClosePositionData] = useState(
    preservedData?.closePositionData || [
      { reference: 'R - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'Y - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'B - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'R - Y', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'Y - B', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'B - R', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
    ]
  );

  const [openPositionData, setOpenPositionData] = useState(
    preservedData?.openPositionData || [
      { reference: 'R - R\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'Y - Y\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'B - B\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
    ]
  );

  const [illuminationData, setIlluminationData] = useState(
    preservedData?.illuminationData || [
      { description: 'Door Lamp', status: 'OK' },
      { description: 'Spacer Heater with Thermostat', status: 'OK' },
      { description: 'AUX. Power Socket', status: 'OK' },
    ]
  );









useEffect(() => {
  const clearFlag = localStorage.getItem('clearTestForm');
  
  if (clearFlag === 'true') {
    
    setClosePositionData([
      { reference: 'R - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'Y - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'B - E', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'R - Y', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'Y - B', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'B - R', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
    ]);

    setOpenPositionData([
      { reference: 'R - R\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'Y - Y\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
      { reference: 'B - B\'', appliedVoltage: '250V', resistanceValue: '', resistanceUnit: 'MΩ' },
    ]);

    setIlluminationData([
      { description: 'Door Lamp', status: 'OK' },
      { description: 'Spacer Heater with Thermostat', status: 'OK' },
      { description: 'AUX. Power Socket', status: 'OK' },
    ]);
    
    
    localStorage.removeItem('testFormData');
    localStorage.removeItem('clearTestForm');
    console.log('Test form cleared based on flag');
  } else {
   
    const savedTestData = localStorage.getItem('testFormData');
    if (savedTestData) {
      try {
        const parsedData = JSON.parse(savedTestData);
        if (parsedData.closePositionData) {
          setClosePositionData(parsedData.closePositionData);
        }
        if (parsedData.openPositionData) {
          setOpenPositionData(parsedData.openPositionData);
        }
        if (parsedData.illuminationData) {
          setIlluminationData(parsedData.illuminationData);
        }
      } catch (error) {
        console.error('Error parsing saved test data:', error);
      }
    }
  }
}, []); 


useEffect(() => {
  
  if (savedGeneralData?.testData) {
    if (savedGeneralData.testData.closePositionData) {
      setClosePositionData(savedGeneralData.testData.closePositionData);
    }
    if (savedGeneralData.testData.openPositionData) {
      setOpenPositionData(savedGeneralData.testData.openPositionData);
    }
    if (savedGeneralData.testData.illuminationData) {
      setIlluminationData(savedGeneralData.testData.illuminationData);
    }
  }
}, [savedGeneralData]);

useEffect(() => {
  
  const testData = {
    closePositionData,
    openPositionData,
    illuminationData
  };
  localStorage.setItem('testFormData', JSON.stringify(testData));
}, [closePositionData, openPositionData, illuminationData]);


useEffect(() => {
  return () => {
    const testData = {
      closePositionData,
      openPositionData,
      illuminationData
    };
    localStorage.setItem('testFormData', JSON.stringify(testData));
  };
}, [closePositionData, openPositionData, illuminationData]);

  const handleClosePositionChange = (index, field, value) => {
    setClosePositionData(prevData => {
      const updatedData = [...prevData];
      updatedData[index] = { ...updatedData[index], [field]: value };
      return updatedData;
    });
  };

  const handleOpenPositionChange = (index, field, value) => {
    setOpenPositionData(prevData => {
      const updatedData = [...prevData];
      updatedData[index] = { ...updatedData[index], [field]: value };
      return updatedData;
    });
  };

  const handleIlluminationChange = (index, value) => {
    setIlluminationData(prevData => {
      const updatedData = [...prevData];
      updatedData[index] = { ...updatedData[index], status: value };
      return updatedData;
    });
  };

  const validateResistanceInput = (value) => {
    return value.replace(/[^0-9.<>]/g, '');
  };
 
  const handleNextClick = () => {
    const testData = {
      closePositionData,
      openPositionData,
      illuminationData
    };
    localStorage.setItem('testFormData', JSON.stringify(testData));
    
    setShowContactForm(true);
  };

const redirectToHome = () => {
  if (window.confirm("Are you sure you want to leave this page")) {
    
    const testData = {
      closePositionData,
      openPositionData,
      illuminationData
    };
    localStorage.setItem('testFormData', JSON.stringify(testData));
    localStorage.setItem('openReportsOnLoad', 'true');
    
    
      window.location.href = "/";
    
  }
};

const handleBackClick = () => {
  const currentTestData = {
    closePositionData,
    openPositionData,
    illuminationData
  };
  localStorage.setItem('testFormData', JSON.stringify(currentTestData));
  
  if (goBack) {
    goBack({
      ...savedGeneralData,
      testData: currentTestData,
      contactTestData: savedGeneralData?.contactTestData,
      operationalChecks: savedGeneralData?.operationalChecks
    });
  } else {
    setShowCircuitBreakerForm(true);
  }
};
 
if (showCircuitBreakerForm) {
  return <CB 
    goBack={() => setShowCircuitBreakerForm(false)}
    savedGeneralData={{
      ...savedGeneralData,
      formData1: savedGeneralData?.formData1,
      testData: {
        closePositionData,
        openPositionData,
        illuminationData
      },
      contactTestData: savedGeneralData?.contactTestData,
      operationalChecks: savedGeneralData?.operationalChecks
    }} 
  />;
}

  if (showContactForm) {
    return <Contact 
      goBack={() => {
        setShowContactForm(false);
      }} 
      savedGeneralData={{
        ...savedGeneralData,
        testData: {
          closePositionData,
          openPositionData,
          illuminationData
        }
      }}
    />;
  }

  return (
    <div className="T1">
      <span className="T2" onClick={redirectToHome}>X</span>

      <div className="T3">
        <div className="T4">
          <div className="T5">
            <h2>INSULATION RESISTANCE TEST</h2>
          </div>

          <div className="T6">
            <div className="T7">
              <h3 className="T8">Breaker Position : CLOSE</h3>
              <div className="T9">
                <table className="T10">
                  <thead>
                    <tr>
                      <th>Reference</th>
                      <th>Applied DC Voltage (V)</th>
                      <th className="T11">Measured Resistance (Ω)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {closePositionData.map((item, index) => (
                      <tr key={index}>
                        <td className="T12">{item.reference}</td>
                        <td>
                          <select
                            className="T13"
                            value={item.appliedVoltage}
                            onChange={(e) =>
                              handleClosePositionChange(index, "appliedVoltage", e.target.value)
                            }
                          >
                            <option value="250V">250V</option>
                            <option value="500V">500V</option>
                            <option value="1000V">1000V</option>
                            <option value="2500V">2500V</option>
                            <option value="5000V">5000V</option>
                          </select>
                        </td>
                        <td className="T14">
                          <input
                            type="text"
                            className="T15"
                            value={item.resistanceValue}
                            onChange={(e) => {
                              const validValue = validateResistanceInput(e.target.value);
                              handleClosePositionChange(index, "resistanceValue", validValue);
                            }}
                            placeholder="Value"
                          />
                          <select
                            className="T16"
                            value={item.resistanceUnit}
                            onChange={(e) =>
                              handleClosePositionChange(index, "resistanceUnit", e.target.value)
                            }
                          >
                            <option value="Ω">Ω</option>
                            <option value="KΩ">KΩ</option>
                            <option value="MΩ">MΩ</option>
                            <option value="GΩ">GΩ</option>
                            <option value="TΩ">TΩ</option>
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="T7">
              <h3 className="T8">Breaker Position : OPEN</h3>
              <div className="T9">
                <table className="T10">
                  <thead>
                    <tr>
                      <th>Reference</th>
                      <th>Applied DC Voltage (V)</th>
                      <th className="T11">Measured Resistance (Ω)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {openPositionData.map((item, index) => (
                      <tr key={index}>
                        <td className="T12">{item.reference}</td>
                        <td>
                          <select
                            className="T13"
                            value={item.appliedVoltage}
                            onChange={(e) =>
                              handleOpenPositionChange(index, "appliedVoltage", e.target.value)
                            }
                          >
                            <option value="250V">250V</option>
                            <option value="500V">500V</option>
                            <option value="1000V">1000V</option>
                            <option value="2500V">2500V</option>
                            <option value="5000V">5000V</option>
                          </select>
                        </td>
                        <td className="T14">
                          <input
                            type="text"
                            className="T15"
                            value={item.resistanceValue}
                            onChange={(e) => {
                              const validValue = validateResistanceInput(e.target.value);
                              handleOpenPositionChange(index, "resistanceValue", validValue);
                            }}
                            placeholder="Value"
                          />
                          <select
                            className="T16"
                            value={item.resistanceUnit}
                            onChange={(e) =>
                              handleOpenPositionChange(index, "resistanceUnit", e.target.value)
                            }
                          >
                            <option value="Ω">Ω</option>
                            <option value="KΩ">KΩ</option>
                            <option value="MΩ">MΩ</option>
                            <option value="GΩ">GΩ</option>
                            <option value="TΩ">TΩ</option>
                          </select>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="T4">
          <div className="T5">
            <h2>ILLUMINATION / HEATING CKT CHECK</h2>
          </div>

          <div className="T6">
            <div className="T9 T17">
              <table className="T10">
                <thead>
                  <tr>
                    <th>Description</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {illuminationData.map((item, index) => (
                    <tr key={index}>
                      <td className="T18">{item.description}</td>
                      <td>
                        <select
                          className={`T13 ${item.status === "OK" ? "T19" : "T20"}`}
                          value={item.status}
                          onChange={(e) => handleIlluminationChange(index, e.target.value)}
                        >
                          <option value="OK">OK</option>
                          <option value="Not OK">Not OK</option>
                        </select>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div className="T21">
        <button className="T22" onClick={handleBackClick}>Back</button>
        <button className="T23" onClick={handleNextClick}>Next</button>
      </div>
    </div>
  );
};

export default TestCards;